module.exports = __webpack_public_path__ + "img/modelo-vrd41.7de5ac92.png";